import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import 'rxjs/add/operator/do';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from 'rxjs';
import { AuthorizationService } from './authorization.service';
import { LoginToken } from 'src/app/models/loginToken';
import { PersonalInfoService } from '../Demographics/personal-info.service';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { configuration } from 'src/environments/environment';
import { AESAlgorithm } from "src/app/Utilities/Crypto/AESAlgorithm";
import { PeriodicElement1 } from "src/app/AdminModule/AdminConfiguration/manage-cpt-codes/manage-cpt-codes.component";
import moment from "moment";
import { stringify } from "querystring";
import { CookieService } from "ngx-cookie-service";
declare var window: any;
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    IsRegisterActivationLink: boolean = configuration.IsRegisterActivationLink;
    constructor(private router: Router, private authService: AuthorizationService
        , private crypto: AESAlgorithm, private cookieService: CookieService) { }
    encryptBodyData(inputdata: string): string {
        var reqbody1 = inputdata.toString();
        if ((reqbody1.indexOf("/") > -1 || (reqbody1.indexOf("-") > -1)) && moment(reqbody1, "MM/DD/YYYY").isValid() == true && moment(reqbody1).format("MM/DD/YYYY") != "Invalid date") {
            var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
            if (!(date_regex.test(reqbody1))) {
                reqbody1 = this.crypto.reqencryptor(reqbody1).toString();
            } else {
                let inputdate: string = moment(reqbody1).format("MM/DD/YYYY");//.toString();// HH:mm:ss a
                reqbody1 = this.crypto.reqencryptor(inputdate).toString();                
            }            
        }
        else if (reqbody1.split('&').length > 0 && reqbody1.indexOf("grant_type") > -1) {
            var paramSplitarray = [];
            reqbody1.split('&').forEach(element => {
                if (element.indexOf("grant_type") == -1)
                    element = element.split("=")[0] + "=" + encodeURIComponent(this.crypto.reqencryptor(element.split("=")[1]))
                paramSplitarray.push(element)
            })
            reqbody1 = paramSplitarray.join("&");


        }
        else {
            reqbody1 = this.crypto.reqencryptor(reqbody1).toString();
        }
        return reqbody1;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // ** Used for when we use IPAddress concept 
        if (this.IsRegisterActivationLink == false) {
            if (req.url.includes(configuration.ClientIpAdressURL) || req.url.includes('api/Activation/ValidateLoginUser1') || req.url.includes('api/Activation/getFacilityByIPAddressByUserId')) {
                if (req.url.indexOf(configuration.ClientIpAdressURL) > -1)
                    return next.handle(req.clone());
            }
        }

        let EncryptedURL: string = req.url;
        // for encryption
        if (req.params) {
            let param = req.url.split('?').length > 0 ? req.url.split('?')[1] : '';
            if (param) {
                var paramSplitarray = [];
                param.split('&&').forEach(element => {
                    element = element.split("=")[0] + "=" + encodeURIComponent(this.crypto.reqencryptor(element.split("=")[1]))
                    paramSplitarray.push(element)
                })
                param = paramSplitarray.join("&&");

                EncryptedURL = req.url.split('?')[0] + "?" + param
            }
        }
        let reqbody = req.body;

        if (reqbody) {
            try {
                if (typeof (reqbody) == "object") {
                    Object.keys(reqbody).forEach(element => {
                        if (reqbody[element]) {
                            if (typeof (reqbody[element]) == "object") {
                                let reqsubbody = reqbody[element];
                                Object.keys(reqsubbody).forEach(ele => {
                                    if (reqsubbody[ele]) {
                                        if (typeof (reqsubbody[ele]) == "object") {
                                            let reqsubbody1 = reqsubbody[ele];
                                            try {
                                                if (Object.keys(reqsubbody1).length > 0) {
                                                    Object.keys(reqsubbody1).forEach(ele1 => {
                                                        if (reqsubbody1[ele1]) {
                                                            reqsubbody1[ele1] = this.crypto.reqencryptor(reqsubbody1[ele1]).toString();
                                                        }
                                                    });
                                                }
                                                else {
                                                    reqsubbody[ele] = this.encryptBodyData(reqsubbody[ele]);
                                                }
                                            }
                                            catch (ex) {
                                                reqsubbody[ele] = this.encryptBodyData(reqsubbody[ele]);
                                            }
                                        }
                                        else {
                                            if ((req.url.toLowerCase().indexOf('fluorocache/') > -1)
                                                && (ele.toLowerCase() == "imagedata" || ele.toLowerCase() == "newfilename")) { }
                                            else {
                                                reqsubbody[ele] = this.encryptBodyData(reqsubbody[ele]);
                                            }
                                        }
                                    }
                                });
                            }
                            else {
                                reqbody[element] = this.encryptBodyData(reqbody[element]);
                            }

                        }
                    })
                }
                else {
                    let parambody = reqbody;
                    if (parambody) {
                        var paramSplitarray = [];
                        parambody.split('&').forEach(element => {
                            if (element.indexOf("grant_type") == -1)
                                element = element.split("=")[0] + "=" + encodeURIComponent(this.crypto.reqencryptor(element.split("=")[1]))
                            paramSplitarray.push(element)
                        })
                        parambody = paramSplitarray.join("&");

                        reqbody = parambody;
                    }
                }
            }
            catch (ex) {
                ;
                console.log(ex);
            }
        }

        ///// need to delete
        // EncryptedURL = req.url;
        // reqbody = req.body;
        ////////////////////////////
        if (req.headers.get('No-Auth') == "True")
            return next.handle(req.clone({ body: reqbody, url: EncryptedURL }));

        let baseurl = req.url.split('api/')[0];
        // if (baseurl === configuration.tokenUrl) {
        // this.cookieService.get('usertoken'), LoginToken.coreAccessToken, this.tokenendtime, '/', null, false, "Strict");
        // this.cookieService.get('clinictoken'), LoginToken.clinicAccessToken, this.tokenendtime, '/', null, false, "Strict");
        if (sessionStorage.getItem('usertoken') != null) {
            // if (this.cookieService.get('usertoken') != null && this.cookieService.get('usertoken') != '') {
            const clonedreq = req;
            const clonedreqone = req.clone({
                body: reqbody,
                url: EncryptedURL,
                headers: req.headers.set("Authorization", "Bearer " + sessionStorage.getItem('usertoken'))
                // headers: req.headers.set("Authorization", "Bearer " + this.cookieService.get('usertoken'))
            });
            return next.handle(clonedreqone)
                .do(
                    succ => { },
                    err => {
                        if (err.status === 401) {
                            // if (this.cookieService.get('usertoken') != null && this.cookieService.get('usertoken') != '') {
                            if (sessionStorage.getItem('gilonidlg') != null) {
                                //     // localStorage.removeItem('userToken');
                                LoginToken.UserId = this.crypto.urlParmeterDecoder(sessionStorage.getItem("gilonidlg")).split('##')[0];
                                LoginToken.UserPassword = this.crypto.urlParmeterDecoder(sessionStorage.getItem("gilonidlg")).split('##')[1];
                                //     alert(LoginToken.UserId);
                                this.authService.userAuthentication(LoginToken.UserId, LoginToken.UserPassword, 1000).subscribe(async (data: any) => {
                                    LoginToken.coreAccessToken = data.access_token;
                                    sessionStorage.removeItem('usertoken');
                                    //$('#usertoken').val(LoginToken.coreAccessToken);
                                    sessionStorage.setItem('usertoken', LoginToken.coreAccessToken);
                                    //         // if (localStorage.getItem('userToken') != null) {
                                    //if ($('#usertoken').val() != null) {
                                    const clonedreqtwo = clonedreqone.clone({
                                        headers: clonedreqone.headers.set("Authorization", "Bearer " + sessionStorage.getItem('usertoken'))
                                        // headers: clonedreq.headers.set("Authorization", "Bearer " + this.cookieService.get('usertoken'))
                                    });
                                    return next.handle(clonedreqtwo).do(() => { });
                                    // }
                                })
                                // }
                            }
                            else {

                                this.router.navigateByUrl('/login');
                            }
                        }

                    }
                );
        }
        else {
            // this.router.navigateByUrl('/login');
            if (sessionStorage.getItem('gilonidlg') != null) {
                //     // localStorage.removeItem('userToken');
                LoginToken.UserId = this.crypto.urlParmeterDecoder(sessionStorage.getItem("gilonidlg")).split('##')[0];
                LoginToken.UserPassword = this.crypto.urlParmeterDecoder(sessionStorage.getItem("gilonidlg")).split('##')[1];
                //     alert(LoginToken.UserId);
                this.authService.userAuthentication(LoginToken.UserId, LoginToken.UserPassword, 1000).subscribe(async (data: any) => {
                    LoginToken.coreAccessToken = data.access_token;
                    sessionStorage.removeItem('usertoken');
                    //$('#usertoken').val(LoginToken.coreAccessToken);
                    sessionStorage.setItem('usertoken', LoginToken.coreAccessToken);
                    //         // if (localStorage.getItem('userToken') != null) {
                    //if ($('#usertoken').val() != null) {
                    const clonedreqtwo = req.clone({
                        headers: req.headers.set("Authorization", "Bearer " + sessionStorage.getItem('usertoken'))
                        // headers: clonedreq.headers.set("Authorization", "Bearer " + this.cookieService.get('usertoken'))
                    });
                    return next.handle(clonedreqtwo).do(() => { });
                    // }
                })
                // }
            }
            else {

                this.router.navigateByUrl('/login');
            }
        }
        // }
        // else if (baseurl === configuration.clinicTokenUrl) {
        //     if (sessionStorage.getItem('clinictoken') != null) {
        //         // if (this.cookieService.get('clinictoken') != null && this.cookieService.get('clinictoken') != '') {
        //         const clonedreq = req;
        //         const clonedreqone = req.clone({
        //             body: reqbody,
        //             url: EncryptedURL,
        //             headers: req.headers.set("Authorization", "Bearer " + sessionStorage.getItem('clinictoken'))
        //             // headers: req.headers.set("Authorization", "Bearer " + this.cookieService.get('clinictoken'))
        //         });
        //         return next.handle(clonedreqone)
        //             .do(
        //                 succ => { },
        //                 err => {
        //                     if (err.status === 401) {
        //                         //alert("Clinic" + LoginToken.UserId);
        //                         //localStorage.removeItem('clinicToken');
        //                         this.clinicTokenGenerate(clonedreq, next);
        //                     }
        //                 }
        //             );
        //     }
        //     else {
        //         const clonedreq = req;
        //         this.clinicTokenGenerate(clonedreq, next);
        //         // this.router.navigateByUrl('/login');
        //     }
        // }
        // else if (baseurl === configuration.billingTokenUrl) {
        //     if (localStorage.getItem('billingToken') != null) {
        //         const clonedreq = req;
        //         const clonedreqone = req.clone({
        //             body: reqbody,
        //             url: EncryptedURL,
        //             headers: req.headers.set("Authorization", "Bearer " + localStorage.getItem('billingToken'))
        //         });
        //         return next.handle(clonedreqone)
        //             .do(
        //                 succ => { },
        //                 err => {
        //                     if (err.status === 401) {
        //                         localStorage.removeItem('billingToken');
        //                         this.billingTokenGenerate(clonedreq, next);
        //                     }
        //                 }
        //             );
        //     } else {
        //         this.router.navigateByUrl('/login');
        //     }
        // }

    }
    // async clinicTokenGenerate(clonedreq: HttpRequest<any>, next: HttpHandler) {
    //     if (this.cookieService.get('clinictoken') != null && this.cookieService.get('clinictoken') != '') {

    //         const clonedreqtwo = clonedreq.clone({
    //             // headers: clonedreq.headers.set("Authorization", "Bearer " + localStorage.getItem('clinicToken'))
    //             headers: clonedreq.headers.set("Authorization", "Bearer " + this.cookieService.get('clinictoken'))
    //         });
    //         return next.handle(clonedreqtwo).do(() => { });

    //     }
    //     else {
    //         this.router.navigateByUrl('/login');
    //     }
    // }

    async clinicTokenGenerate(clonedreq: HttpRequest<any>, next: HttpHandler) {
        // if ($('#clinictoken').val() != null) {
        if (sessionStorage.getItem('gilonidlg') != null) {
            LoginToken.UserId = this.crypto.urlParmeterDecoder(sessionStorage.getItem("gilonidlg")).split('##')[0];
            LoginToken.UserPassword = this.crypto.urlParmeterDecoder(sessionStorage.getItem("gilonidlg")).split('##')[1];
            await this.authService.clinicAuthentication(LoginToken.UserId, LoginToken.UserPassword, 2000).subscribe((data: any) => {
                LoginToken.clinicAccessToken = data.access_token;
                sessionStorage.removeItem('clinictoken');
                $('#clinictoken').val(LoginToken.clinicAccessToken);
                sessionStorage.setItem('clinictoken', LoginToken.clinicAccessToken);
                if (sessionStorage.getItem('clinictoken') != null) {
                    // if ($('#clinictoken').val() != null) {
                    const clonedreqtwo = clonedreq.clone({
                        headers: clonedreq.headers.set("Authorization", "Bearer " + sessionStorage.getItem('clinictoken'))
                        // headers: clonedreq.headers.set("Authorization", "Bearer " + $('#clinictoken').val())
                    });
                    return next.handle(clonedreqtwo).do(() => { });
                }
            });
        }
        //}
        else {
            this.router.navigateByUrl('/login');
        }
    }

    // async billingTokenGenerate(clonedreq: HttpRequest<any>, next: HttpHandler) {
    //     await this.authService.clinicAuthentication(LoginToken.UserId, LoginToken.UserPassword, 2000).subscribe((data: any) => {
    //         LoginToken.billingAcessToken = data.access_token;
    //         localStorage.setItem('billingToken', LoginToken.billingAcessToken);
    //         if (localStorage.getItem('billingToken') != null) {
    //             const clonedreqtwo = clonedreq.clone({
    //                 headers: clonedreq.headers.set("Authorization", "Bearer " + localStorage.getItem('billingToken'))
    //             });
    //             return next.handle(clonedreqtwo).do(() => { });
    //         }
    //     });
    // }


}